import React from "react";

import "../Exports.css";
import { connect } from "react-redux";
import ExportCasesTable from "./Cases/ExportCasesTable";

const ExportSearchResults = () => {
  return (
    <div id="content-outer-wrapper" className="flex flex-expand">
      <div className="flex" style={{ width: "100%" }}>
        <div id="exports-content-wrapper">
           <ExportCasesTable />
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
});

export const ConnectedExportSearchResults =
  connect(mapStateToProps)(ExportSearchResults);

export default ConnectedExportSearchResults;
